import React from "react";
import {
  Card,
  CardSubtitle,
  CardBody,
  CardText,
  Badge,
  Row,
  Col,
} from "reactstrap";
var QRCode = require("qrcode.react");

const Qr2fa = React.memo((props) => {
  const { user } = props;
  return (
    <Row>
      <Col md={6} sm={12}>
        <Card>
          <CardBody className="text-center">
            <CardSubtitle>Scan QR code</CardSubtitle>
            <QRCode
              id="123456"
              value={user.uri}
              size={200}
              level={"L"}
              includeMargin={true}
            />
          </CardBody>
        </Card>
      </Col>
      <Col md={6} sm={12} className="d-flex">
        <Card>
          <CardBody className="text-center">
            <CardText>
              Scan the qr code with your smart phone authentication app (use
              Google Auth or Microsoft Auth)
              <br></br>
              <Badge color="info">Save this code</Badge>
              <br></br>
              <b>{user.key}</b>
            </CardText>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
});

export default Qr2fa;
